import {
  get,
  template,
  omitBy,
  isNull,
  isNumber,
  isBoolean,
  isEmpty,
  isString,
  compact,
  isFunction,
} from "utils/lodash";

const helper = {
  normalizeParams: (object: any) =>
    omitBy(object, (val: any) => {
      return (
        val === "" ||
        val === undefined ||
        isNull(val) ||
        (!isNumber(val) && !isBoolean(val) && isEmpty(val))
      );
    }),
  sleep: (ms: number) => new Promise((resolve) => setTimeout(resolve, ms)),
  interpolateContent: (content: any, attributes: any) => {
    return template(content, {
      interpolate: /{{([\s\S]+?)}}/g,
    })(attributes);
  },
  formatShopMetatags: (data?: any, metas?: any) => {
    const title =
      get(data, "meta.title") ||
      get(data, "name") ||
      "Lookme - Thông tin review và đặt lịch làm đẹp hơn 7000 địa điểm";
    const description =
      get(data, "meta.description") ||
      "Lookme là nền tảng đặt lịch làm đẹp bao gồm spa, massage, làm tóc, làm móng, gội đầu, phẫu thuật thẩm mỹ. Với hơn 7000 địa điểm có review, bình luận, hình ảnh";
    const _metas = {
      title,
      description,
      images: [
        {
          url: helper.imageUrl(get(data, "avatar.url")),
          width: 1200,
          height: 630,
        },
      ],
      openGraph: {
        title,
        description,
        images: [
          {
            url: helper.imageUrl(get(data, "avatar.url")),
            width: 1200,
            height: 630,
          },
        ],
        url: `${process.env.NEXT_PUBLIC_APP_URL || "https://lookme.vn"}/${get(
          data,
          "slug",
        )}`,
        locale: "vi_VN",
        type: "website",
      },
      twitter: {
        card: "summary_large_image",
        title,
        description,
        images: [
          {
            url: helper.imageUrl(get(data, "avatar.url")),
            width: 1200,
            height: 630,
          },
        ],
      },
    };
    return {
      ..._metas,
      ...metas,
    };
  },
  formatHomeMetatags: (data?: any, metas?: any) => {
    const title =
      get(data, "meta.title") ||
      get(data, "name") ||
      "Lookme - Nền tảng đặt lịch làm đẹp" ||
      "Lookme - Thông tin review và đặt lịch làm đẹp hơn 7000 địa điểm";
    const description =
      get(data, "meta.description") ||
      "Lookme là nền tảng đặt lịch làm đẹp bao gồm spa, massage, làm tóc, làm móng, gội đầu, phẫu thuật thẩm mỹ. Với hơn 7000 địa điểm có review, bình luận, hình ảnh";
    const baseUrl = process.env.NEXT_PUBLIC_APP_URL || "https://lookme.vn";
    const ogImageUrl = `${baseUrl}/banner.jpg`;
    console.log({ ogImageUrl });
    const _metas = {
      title,
      description,
      metadataBase: new URL(baseUrl),
      images: [
        {
          url: ogImageUrl,
          width: 1200,
          height: 630,
        },
      ],
      keywords: [
        "làm đẹp",
        "spa",
        "massage",
        "salon tóc",
        "làm móng",
        "đặt lịch",
        "review",
        "Lookme",
      ],
      openGraph: {
        title,
        description,
        url: baseUrl,
        siteName: "Lookme",
        locale: "vi_VN",
        type: "website",
        images: [
          {
            url: ogImageUrl,
            width: 1200,
            height: 630,
            alt: "Lookme - Nền tảng đặt lịch làm đẹp hàng đầu Việt Nam",
          },
        ],
      },
      twitter: {
        card: "summary_large_image",
        title,
        description,
        images: [
          {
            url: ogImageUrl,
            alt: "Lookme - Nền tảng đặt lịch làm đẹp hàng đầu Việt Nam",
          },
        ],
      },
      other: {
        "google-site-verification":
          "CK0IOdgIpSiWqlamRJUjJyjbTtJXS2ES5I4aNEF9vdk",
      },
    };
    console.log("formatHomeMetatags", { _metas });
    return {
      ..._metas,
      ...metas,
    };
  },
  formatMetatags: (
    _data?: any,
    type: "home" | "shop" | "service" | "campaignPackage" = "shop",
  ) => {
    const handler: any = {
      shop: () => helper.formatShopMetatags(_data),
      home: () => helper.formatHomeMetatags(_data),
    };
    const data = isFunction(handler[type]) ? handler[type]() : {};

    return {
      title: get(data, "title"),
      description: get(data, "description"),
      images: get(data, "images"),
      openGraph: get(data, "openGraph"),
      twitter: get(data, "twitter"),
      icons: {
        icon: [
          {
            url: `/favicon-16x16.png`,
            sizes: "16x16",
            type: "image/png",
          },
          {
            url: `/favicon-32x32.png`,
            sizes: "32x32",
            type: "image/png",
          },
          {
            url: `/favicon.ico`,
            sizes: "any",
          },
        ],
        shortcut: `/logo-192x192.png`,
        apple: `/apple-touch-icon.png`,
      },
      manifest: `/site.webmanifest`,
      other: get(data, "other"),
    };
  },
  formatShop: (shop: any) => {
    console.log({ shop });
    return {
      ...shop,

      thumbnail:
        get(shop, "avatar.sizes.thumbnail.url") ||
        get(shop, "avatar.sizes.card.url") ||
        get(shop, "avatar.url"),
    };
  },
  imageUrl: (item?: string | object) => {
    const url = isString(item) ? item : get(item, "url", "");
    if (url === "") return "";

    // Nếu URL đã là absolute URL, trả về nguyên vẹn
    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    }

    // Nếu URL đã chứa domain của IMAGE_URL, trả về nguyên vẹn
    if (url.includes(process.env.NEXT_PUBLIC_IMAGE_URL || "")) {
      return url;
    }

    // Thêm domain vào URL relative
    const baseUrl = process.env.NEXT_PUBLIC_IMAGE_URL || "";
    return baseUrl ? `${baseUrl}${url.startsWith("/") ? url : `/${url}`}` : url;
  },
  lexicalToString: (item?: string | object) => {
    const url = isString(item) ? item : get(item, "url", "");
    if (url === "") return "";

    // Nếu URL đã là absolute URL, trả về nguyên vẹn
    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    }

    // Nếu URL đã chứa domain của IMAGE_URL, trả về nguyên vẹn
    if (url.includes(process.env.NEXT_PUBLIC_IMAGE_URL || "")) {
      return url;
    }

    // Thêm domain vào URL relative
    const baseUrl = process.env.NEXT_PUBLIC_IMAGE_URL || "";
    return baseUrl ? `${baseUrl}${url.startsWith("/") ? url : `/${url}`}` : url;
  },
  callAll: async (...promises: (() => Promise<any>)[]) => {
    try {
      const results = await Promise.all(
        promises.map((promise, index) =>
          promise().catch((error) => {
            throw new Error(`Error in promise [${index}]: ${error.message}`);
          }),
        ),
      );
      return results;
    } catch (error: any) {
      console.error("Error in callAll:", error.message);
      throw error;
    }
  },
};

export default helper;
